import React, { useContext } from 'react';
import ModalWrapper from '@v2/components/GDS/Modal';
import DataTableWrapper from '@v2/components/GDS/DataTable';
import CardContainer from '@components/redesign/CardContainer';
import { useDynamicGraphQLQuery } from 'hooks/useDynamicGraphQLQuery';
import KpiDefinitionData from 'service/KpiDefinitionData';
import { FilterContext } from 'components/FilterBar/FilterProvider';

interface ReachDetailsModalProps {
  showModal: boolean;
  onCloseModal: () => void;
}

interface ReachDetailsData {
  plant: string;
  line: string;
  tube: string;
  sku: string;
}

const ReachDetailsModal: React.FC<ReachDetailsModalProps> = ({
  showModal,
  onCloseModal,
}) => {
  const { selectedProduct } = useContext(FilterContext);
  const { data, isLoading, error } = useDynamicGraphQLQuery(
    'getReachDetailsTable',
    {},
    true,
    'Manufacturing/IPC'
  );

  // Define table columns
  const columns = [
    {
      columnKey: 'plant',
      header: 'PLANT',
      width: '25%',
    },
    {
      columnKey: 'line',
      header: 'LINE',
      width: '25%',
    },
    {
      columnKey: 'tube',
      header: 'TUBE',
      width: '25%',
    },
    {
      columnKey: 'sku',
      header: "SKU'S",
      width: '25%',
    },
  ];

  // Extract reach details data from the GraphQL response
  const tableData: ReachDetailsData[] =
    data?.getIPCReachDetailsTableView?.data?.reachDetails || [];

  return (
    <ModalWrapper
      showModal={showModal}
      onCloseModal={onCloseModal}
      title="IPC - Reach Details"
      type="XL"
      closeOnOutsideClick={false}
      style={{ width: '100%' }}
    >
      {error && (
        <div style={{ color: 'red', marginBottom: '16px' }}>
          Error loading data:{' '}
          {Array.isArray(error)
            ? error.map((e) => e.message).join(', ')
            : 'Unknown error'}
        </div>
      )}

      <CardContainer
        title="Reach Details"
        dataDefinitions={{
          sections:
            KpiDefinitionData[selectedProduct?.productId]?.valueCreation
              ?.valueRealizationReachDetails ?? [],
        }}
        isAccordion={false}
        showInfoIcon={true}
        isLoading={isLoading}
      >
        <DataTableWrapper
          data={tableData}
          columns={columns}
          isLoading={isLoading}
          noDataTitleText="No Data Found"
          enableSorting={false}
          pageSize={10}
          // showTitle={false}
          showDescription={false}
          showColumnFilters={false}
        />
      </CardContainer>
    </ModalWrapper>
  );
};

export default ReachDetailsModal;
